export enum EmploymentType {
    Vollzeit = "Vollzeit",
    Teilzeit = "Teilzeit",
    VollzeitoderTeilzeit = "Vollzeit oder Teilzeit",
    freieMitarbeitFreelancer = "Freelancer*in",
    Praktikum = "Praktikum",
    TraineeVolontär = "Trainee / Volontär*in",
    Werkstudentin = "Werkstudent*in",
    Ausbildung = "Ausbildung"
}